import { render, staticRenderFns } from "./TrainingComp.vue?vue&type=template&id=a8d4ebde&scoped=true"
import script from "./TrainingComp.vue?vue&type=script&lang=js"
export * from "./TrainingComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d4ebde",
  null
  
)

export default component.exports